import { render, staticRenderFns } from "./LazyList.vue?vue&type=template&id=2991df03&"
import script from "./LazyList.vue?vue&type=script&lang=js&"
export * from "./LazyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports